import React from 'react'
import './ShowMoreButton.css'
import './Modal.css'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close';
import Modal from 'react-modal'
import Chip from '@material-ui/core/Chip'

const contentStyles = {
  content: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  }
}

export default class ShowMoreButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      category: true
    }
    this.onOpenModalHandler = this.onOpenModalHandler.bind(this)
    this.onCloseModalHandler = this.onCloseModalHandler.bind(this)
  }

  componentDidMount() {
    Modal.setAppElement('#root');
  }

  onOpenModalHandler(e) {
    this.setState({
      isModalOpen: true
    })
  }

  onCloseModalHandler(e) {
    this.setState({
      isModalOpen: false
    })
  }

  showToggleSectionButton() {
    return this.props.widget.showToggleSectionButton
  }

  showSectionToggleButtonText() {
    const { buttonText } = this.props.widget.showToggleSectionButton
    return this.state.category ? buttonText[1] : buttonText[0]
  }

  showSectionToggleTitleText() {
    const { category } = this.state
    const { showToggleSectionButton, modalTitle } = this.props.widget
    return showToggleSectionButton ?
    ( category ? showToggleSectionButton.modalTitle[0] : showToggleSectionButton.modalTitle[1] )
    : modalTitle
  }

  getFilteredData() {
    const category = this.state.category ? 'office' : 'personal'
    return this.props.widget.data.filter(project => {
      return project.category === category
    })
  }

  showToggleButton() {
    return (
      <div className="modal-show-section-toggle-button">
        <Button variant="contained" color="secondary" onClick={() => this.toggleSection()}>{ this.showSectionToggleButtonText() }</Button>
      </div>
    )
  }

  toggleSection() {
    this.setState({
      category: !this.state.category
    })
  }

  renderToolsList(list) {
    let arrToolsList = []
    if (!Array.isArray(list)) {
      arrToolsList = Array.from(list.split(','))
    } else {
      arrToolsList = list
    }

    return arrToolsList.map((tool, idx) => <Chip className='tool-chip' color='secondary' key={idx} size='small' label={tool}/>)
  }

  render() {
    const { widget } = this.props
    return (
      <div className='show-more-button'>
        <Button key='show-more-button' size='large' variant='contained' color='primary' onClick={this.onOpenModalHandler} className='see-more'>{ this.props.text }</Button>
        <Modal
          closeTimeoutMS={300}
          isOpen={this.state.isModalOpen}
          onRequestClose={this.onCloseModalHandler}
          style={contentStyles}
        >
          <div className='close-modal-button-top'>
            <IconButton onClick={this.onCloseModalHandler}>
              <CloseIcon />
            </IconButton>
          </div>
          { widget.showDataOnModal? 
            <div className='modal-content'>
              <h1>{this.showSectionToggleTitleText()}</h1>
              { this.showToggleSectionButton() && this.showToggleButton() }
              {
                this.getFilteredData().map((element, idx) => {
                  return (
                    <div key={idx} className='project-details'>
                      <img src={element.img} className='modal-image' alt={element.title} />
                      <h3>{element.title} {element.client && <span>({element.client})</span>}</h3>
                      { element.url && <a className="goto-url" href={element.url} target="_blank" rel="noopener noreferrer" >{element.url}</a> }
                      <p>{element.desc} {element.shortDesc}</p>
                      <p>{this.renderToolsList(element.tools)}</p>
                    </div>
                  )
                })
              }
            </div>
          : null }

          <div className='close-modal-button-bottom'>
            <Button size='large' variant='contained' color='primary' className='close-modal' onClick={this.onCloseModalHandler}>Close This</Button>
          </div>
        </Modal>
      </div>
    )
  }
}